"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
export function useIntersectionObserver(onIntersection) {
  const $ = _c(3);
  const intersectionElementRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== onIntersection) {
    t0 = () => {
      if (intersectionElementRef.current) {
        const observer = new IntersectionObserver(t2 => {
          const [entry] = t2;
          if (entry.isIntersecting) {
            onIntersection(true);
            observer.disconnect();
          }
        }, {
          threshold: 0.1
        });
        observer.observe(intersectionElementRef.current);
        return () => observer.disconnect();
      }
    };
    t1 = [onIntersection];
    $[0] = onIntersection;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return intersectionElementRef;
}